import { gql } from '@apollo/client';

export const CREATE_EDITOR_BACKGROUND = gql`
  mutation CreateEditorBackground(
    $fields: CreateEditor_backgroundsFieldsInput!
  ) {
    createEditor_backgrounds(input: { fields: $fields }) {
      editor_backgrounds {
        objectId
        width
        height
        orientation
        file {
          url
        }
      }
    }
  }
`;

export const CREATE_EDITOR_BACKGROUND_DEFAULT = gql`
  mutation CreateEditorBackgroundDefault(
    $fields: CreateEditor_backgrounds_defaultFieldsInput!
  ) {
    createEditor_backgrounds_default(input: { fields: $fields }) {
      editor_backgrounds_default {
        objectId
        isGlobal
        width
        height
        orientation
        file {
          url
        }
      }
    }
  }
`;

export const GET_EDITOR_BACKGROUNDS = gql`
  query EditorBackgrounds($limit: Int!, $orientation: String!, $after: String) {
    findEditorBackgrounds(
      first: $limit
      after: $after
      order: createdAt_DESC
      where: { orientation: { equalTo: $orientation } }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          objectId
          createdAt
          org_pointer {
            objectId
          }
          width
          height
          file {
            url
          }
          tags {
            edges {
              node {
                objectId
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_EDITOR_BACKGROUNDS_BY_TAG = gql`
  query EditorBackgroundsByTag($tag: String!, $limit: Int!, $after: String) {
    findEditorBackgrounds(
      first: $limit
      after: $after
      order: createdAt_DESC
      where: { tags: { have: { name: { equalTo: $tag } } } }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          objectId
          org_pointer {
            objectId
          }
          width
          height
          file {
            url
          }
          tags {
            edges {
              node {
                objectId
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_EDITOR_BACKGROUNDS_BY_TAG_AND_ORIENTATION = gql`
  query EditorBackgroundsByTag(
    $tag: String!
    $limit: Int!
    $orientation: String!
    $after: String
  ) {
    findEditorBackgrounds(
      first: $limit
      after: $after
      order: createdAt_DESC
      where: {
        orientation: { equalTo: $orientation }
        tags: { have: { name: { equalTo: $tag } } }
      }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          objectId
          org_pointer {
            objectId
          }
          width
          height
          file {
            url
          }
          tags {
            edges {
              node {
                objectId
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_EDITOR_BACKGROUNDS_DEFAULT = gql`
  query EditorBackgroundsDefault(
    $limit: Int!
    $orientation: String!
    $after: String
  ) {
    editor_backgrounds_defaults(
      first: $limit
      after: $after
      order: order_ASC
      where: { orientation: { equalTo: $orientation } }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          objectId
          isGlobal
          width
          height
          createdAt
          file {
            url
          }
          tags {
            edges {
              node {
                objectId
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_EDITOR_BACKGROUNDS_DEFAULT_BY_TAG = gql`
  query EditorBackgroundsDefaultByTag(
    $tag: String!
    $limit: Int!
    $after: String
  ) {
    editor_backgrounds_defaults(
      first: $limit
      after: $after
      order: order_ASC
      where: { tags: { have: { name: { equalTo: $tag } } } }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          objectId
          isGlobal
          width
          height
          file {
            url
          }
          tags {
            edges {
              node {
                objectId
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_EDITOR_BACKGROUNDS_DEFAULT_BY_TAG_AND_ORIENTATION = gql`
  query EditorBackgroundsDefaultByTag(
    $tag: String!
    $limit: Int!
    $orientation: String!
    $after: String
  ) {
    editor_backgrounds_defaults(
      first: $limit
      after: $after
      order: order_ASC
      where: {
        orientation: { equalTo: $orientation }
        tags: { have: { name: { equalTo: $tag } } }
      }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          objectId
          isGlobal
          width
          height
          file {
            url
          }
          tags {
            edges {
              node {
                objectId
                name
              }
            }
          }
        }
      }
    }
  }
`;
